import { render } from "./BaseInputHint.vue?vue&type=template&id=42d96f22"
import script from "./BaseInputHint.vue?vue&type=script&lang=js"
export * from "./BaseInputHint.vue?vue&type=script&lang=js"
script.render = render

export default script